import React from 'react';
import { Fragment, useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { Row, Alert } from 'react-bootstrap';
import FormBusca from './form_busca';
import EducacaoService from '../../../../../services/contasEducacao-auth';
import Receita from './receita';


const ListarReceitas = () => {

    const [receitas, setReceitas] = useState([]);
    const [editar, setEditar] = useState("");
    const [vazio, setVazio] = useState(false);
    const [receita, setReceita] = useState("");


    async function fetchReceitas() {
        const response = await EducacaoService.listarReceita();
        if (response.data.length >= 1) {
            setReceitas(response.data)
            setVazio(false)
        } else {
            setReceitas([])
            setVazio(true)
        }
    }

    const handleEditar = (id) => {
        setReceita(id);
        setEditar(true)
    }


    const deletar = async (id) => {
        if (window.confirm('Tem certeza que deseja deletar a arrecadação?')) {
            await EducacaoService.deletarReceita(id)
            alert("Arrecadação deletada com sucesso!")
            fetchReceitas();
        }
    }

    useEffect(() => {
        fetchReceitas();
    }, []);



    if (editar) {
        return (
            <Navigate to={`/restrito/educacao/receitas/editar/${receita}`} />
        )
    }
    else {
        return (
            <Fragment>
                <Fragment>
                    <FormBusca
                        setReceitas={setReceitas}
                        setVazio={setVazio}
                        fetchReceitas={fetchReceitas}
                    />
                </Fragment>
                {vazio ? <Fragment>
                    <Alert variant='danger'>Sua busca não gerou nenhum resultado :(</Alert>
                </Fragment> :
                    <Fragment>
                        <Row xs={1} lg={3}>
                            {receitas.map((receita, index) =>
                                <Receita
                                    fetchReceitas={fetchReceitas}
                                    receita={receita}
                                    key={index}
                                    editar={handleEditar}
                                    deletar={deletar}
                                />
                            )}
                        </Row>
                    </Fragment>}
            </Fragment>

        )
    }
}

export default ListarReceitas;